<template>
  <div v-if="tagList">
    <dara-header size="sm">{{ $t('followed-tags') }}</dara-header>
    <dara-invisible v-if="tagList.length">
      <dara-tag
        v-for="tag in tagList"
        :key="tag.id"
        :to="getTagLink(tag)"
        :label="tag.name"
        class="mr--md mb--md" />
    </dara-invisible>
    <dara-invisible v-else>
      <dara-p color="info">( {{ $t('empty-followed-tags') }} )</dara-p>
    </dara-invisible>
  </div>
</template>

<script>
import { fetchFollowed, getTagLink } from '@/modules/tag/tag.service';

export default {
  name: 'DaraHomeFollowedTags',
  data() {
    return {
      tagList: null,
    };
  },
  mounted() {
    this.fetch();
  },
  methods: {
    getTagLink,
    fetch() {
      fetchFollowed()
        .then(({ data }) => {
          this.tagList = data;
        })
        .catch();
    },
  },
};
</script>
